import { lazy, Suspense } from "react";

// Defers recharts+d3 (~2MB raw) into an async chunk. Charts use
// ResponsiveContainer (client-sized, empty on the server), so rendering the
// null fallback during SSR and loading after hydration is not a regression.
const AdherenceChartNewImpl = lazy(() => import("./AdherenceChartNew.impl"));

const AdherenceChartNew = (props) => (
  <Suspense fallback={null}>
    <AdherenceChartNewImpl {...props} />
  </Suspense>
);

export default AdherenceChartNew;
